import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './MobileNavigation.styles';
const MobileNavigation = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { "aria-label": "Mobile menu", "data-active": props.active ? (props.activeLink !== '' ? 'child-open' : 'open') : 'closed' },
            React.createElement(S.Inner, null,
                React.createElement(S.Scroll, null,
                    props.links.map((link) => (React.createElement(FocusRing, { key: `mobile-${link.id}`, focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { id: `mobile-${link.id}-top-link`, ...(link.children.length > 0
                                ? { as: 'button', onClick: () => handleTopLinkClick(link) }
                                : { href: link.url, target: link.target }), "data-active": props.activeLink === link.id },
                            link.text,
                            " ",
                            getSvgFromSystem(SystemIcon.Chevron))))),
                    React.createElement(S.Bottom, null,
                        props.quickLinks.map((link) => (React.createElement(FocusRing, { key: `mobile-${link.id}`, focusRingClass: "focus-ring" },
                            React.createElement(S.Link, { href: link.url, target: link.target },
                                link.text,
                                " ",
                                getSvgFromSystem(SystemIcon.Chevron))))),
                        React.createElement(S.ButtonsWrapper, { "data-variant": "dark" },
                            props.joinCta && (React.createElement(LinkButton, { branding: "solid", href: props.joinCta.url, target: props.joinCta.target, title: props.joinCta.text ?? 'Join Us' })),
                            React.createElement(LinkButton, { branding: "outline", href: props.accountCta.url, target: props.accountCta.target, title: props.accountCta.text
                                    ? props.accountCta.text
                                    : props.joinCta
                                        ? 'My RCR Login'
                                        : 'Go to MyRCR' })))))),
        props.links.map((link) => (link.children.length > 0 ? renderLevelTwo(link) : null))));
    async function handleTopLinkClick(link) {
        if (link.id === props.activeLink) {
            props.setActiveLink('');
            props.setActiveSecond('');
        }
        else if (props.activeLink !== '') {
            props.setActiveSecond('');
            props.setActiveLink(link.id);
        }
        else {
            props.setActiveSecond('');
            props.setActiveLink(link.id);
        }
    }
    async function handleSecondLevelClick(id) {
        if (id === props.activeSecond) {
            props.setActiveSecond('');
        }
        else if (props.activeSecond !== '') {
            props.setActiveSecond('');
            props.setActiveSecond(id);
        }
        else {
            props.setActiveSecond(id);
        }
    }
    function renderLevelTwo(link) {
        return (React.createElement(React.Fragment, { key: `mobile-${link.id}-level-wrapper` },
            React.createElement(S.Container, { as: "div", "aria-labelledby": `mobile-${link.id}-top-link`, "data-active": props.activeLink === link.id
                    ? props.activeSecond !== ''
                        ? 'child-open'
                        : 'open'
                    : 'closed', "data-level": link.children.length > 1 ? 2 : 3 },
                React.createElement(S.Inner, null,
                    React.createElement(S.BackButton, { onClick: () => props.setActiveLink('') },
                        getSvgFromSystem(SystemIcon.Chevron),
                        " Back"),
                    React.createElement(S.Scroll, { "data-child": true }, link.children.length > 1 ? (React.createElement(React.Fragment, null,
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.Link, { href: link.url, target: link.target, "data-highlight": true }, link.text)),
                        renderLevelTwoLinks(link.children))) : (React.createElement(React.Fragment, null,
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.Link, { href: link.url, target: link.target, "data-highlight": true }, link.text)),
                        renderLevelThreeLinks(link.id, link.children[0].children)))))),
            link.children.length > 1 &&
                link.children.map((levelTwo) => (React.createElement(S.Container, { "aria-labelledby": `mobile-${levelTwo.id}-level-two-link`, as: "div", key: `mobile-${levelTwo.id}-child-links`, "data-active": props.activeSecond === levelTwo.id ? 'open' : 'closed', "data-level": 3 },
                    React.createElement(S.Inner, null,
                        React.createElement(S.BackButton, { onClick: () => props.setActiveSecond('') },
                            getSvgFromSystem(SystemIcon.Chevron),
                            " Back"),
                        React.createElement(S.Scroll, { "data-child": true },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.Link, { href: levelTwo.url, target: levelTwo.target, "data-highlight": true },
                                    levelTwo.text,
                                    " ",
                                    getSvgFromSystem(SystemIcon.Chevron))),
                            renderLevelThreeLinks(levelTwo.id, levelTwo.children))))))));
    }
    function renderLevelTwoLinks(links) {
        return (React.createElement(React.Fragment, null, links.map((link) => (React.createElement(FocusRing, { key: `mobile-${link.id}`, focusRingClass: "focus-ring" },
            React.createElement(S.Link, { id: `mobile-${link.id}-level-two-link`, ...(link.children.one.length > 0
                    ? { as: 'button', onClick: () => handleSecondLevelClick(link.id) }
                    : { href: link.url, target: link.target }) },
                link.text,
                " ",
                getSvgFromSystem(SystemIcon.Chevron)))))));
    }
    function renderLevelThreeLinks(id, cols) {
        return (React.createElement(React.Fragment, null,
            cols.one.map((group, index) => (React.createElement(S.LinkGroup, { key: `mobile-${id}-0${index}-level-three-col-1` }, group.map((link) => (React.createElement(FocusRing, { key: `mobile-${link.id}`, focusRingClass: "focus-ring" },
                React.createElement(S.Link, { ...(!!link && link.url !== ''
                        ? { href: link.url, target: link.target }
                        : { as: 'span' }) }, link.text))))))),
            cols.two.length
                ? cols.two.map((group, index) => (React.createElement(S.LinkGroup, { key: `mobile-${id}-0${index}-level-three-col-2` }, group.map((link) => (React.createElement(FocusRing, { key: `mobile-${link.id}`, focusRingClass: "focus-ring" },
                    React.createElement(S.Link, { ...(link.url !== ''
                            ? { href: link.url, target: link.target }
                            : { as: 'span' }) }, link.text)))))))
                : null));
    }
};
export default MobileNavigation;
